import PropTypes from "prop-types";
import React from "react";
import { StyleSheet, View, Keyboard } from "react-native";
import TouchableOpacity from "app/components/TouchableOpacity";
import Text from "app/components/Text";
import ENV from "app/utils/ENV";

import chapterActions from "app/utils/chapterActions";
import momentActions from "app/utils/momentActions";
import valueActions from "app/utils/valueActions";
import noteActions from "app/utils/noteActions";

import textHelpers from "app/utils/textHelpers";
import timeHelpers from "app/utils/timeHelpers";
import colorHelpers from "app/utils/colorHelpers";
import valueHelpers from "app/utils/valueHelpers";
import frequencyHelpers from "app/utils/frequencyHelpers";
import locationHelpers from "app/utils/locationHelpers";

import Hoverable from "app/components/Hoverable";
import Tooltip from "app/components/Tooltip";

import { styleSheet } from "app/utils/styleSheet";
import {
  Feather,
  FontAwesome,
  MaterialIcons,
  MaterialCommunityIcons,
  AntDesign,
} from "@expo/vector-icons";

import Icon from "app/components/Icon";
import TextInput from "app/components/TextInput";
import Autocomplete from "app/components/Autocomplete";
import Tag from "app/components/chapter/Tag";

import ValueListItem from "app/components/ValueListItem";

import { StyleContext } from "app/contexts/Style";

export default class MomentComposer extends React.Component {
  static contextType = StyleContext;
  static propTypes = {
    // backgroundColor: PropTypes.string,
  };

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      chapter: props.chapter,
      text: props.text || "",
      meta: ENV.WEB ? false : true,
      shift: props.defaultToNote ? true : false,
      noSuggestions: props.noSuggestions,
      noSuggestions: true,
      firstSuggestion: null,
      parents: [],
    };
  }

  componentDidMount = () => {
    // console.log("prevent autofocus", this.props.preventAutoFocus);
  };

  render() {
    let { chapter, chapterId, disableSuggestions, noIcon } = this.props;
    let { text, meta, shift, firstSuggestion, noSuggestions, parents } =
      this.state;
    if (text?.includes("#")) noSuggestions = false;
    return (
      <View
        style={{
          flexDirection: "column",
          alignItems: "flex-start",
          width: "100%",
        }}
      >
        <View
          style={{
            flexDirection: "row",
            alignItems: "flex-start",
            width: "100%",
          }}
        >
          {noIcon ? (
            <View style={{ width: this.context.sizes.base }} />
          ) : !chapter?.id ? (
            <Text
              style={[
                styleSheet.bullet,
                styleSheet.largeBullet,
                !ENV.WEB && styleSheet.mobileLargeBullet,
                { borderWidth: 0 },
              ]}
            >
              +
            </Text>
          ) : (
            <Hoverable>
              {(isHovered) => (
                <TouchableOpacity onPress={() => null}>
                  <View>
                    <Text
                      style={[
                        styleSheet.bullet,
                        styleSheet.largeBullet,
                        !ENV.WEB && styleSheet.mobileLargeBullet,
                        { borderWidth: 0 },
                        // isHovered && {
                        //   backgroundColor: this.context.colors.trim,
                        // },
                      ]}
                    >
                      +
                    </Text>
                    {/*isHovered && (
                      <Tooltip
                        style={{ top: 0, left: this.context.sizes.bulletWidth }}
                      >
                        Suggestions
                      </Tooltip>
                    )*/}
                  </View>
                </TouchableOpacity>
              )}
            </Hoverable>
          )}

          <Autocomplete
            keyboardAccType={"composer"}
            inputRef={(c) => {
              if (this.props.inputRef) {
                this.props.inputRef(c);
              }
              return (this[`ref-composer`] = c);
            }}
            preventScrollTo
            defaultFocus={this.props.defaultFocus}
            multiline
            autoHeight
            onChangeHeight={this.props.onChangeHeight}
            extraStyle={{
              flex: 1,
            }}
            suggestChapters
            placeholder={this.props.placeholder}
            placeholderTextColor={
              this.props.placeholderTextColor || this.context.colors.trim
            }
            noSuggestions={noSuggestions}
            onPressTab={() => {
              if (disableSuggestions) return;
              if (!text?.length) {
                !!this.props.onIndent && this.props.onIndent();
              }
              this.setState({
                noSuggestions: !noSuggestions,
                firstSuggestion: null,
              });
            }}
            clearSuggestionsOnEscape
            onCancel={() => {
              this.setState({ noSuggestions: true, firstSuggestion: null, text: "", parents: [] });
            }}
            // inputStyle={{ flex: 1 }}
            query={text}
            onChangeText={async (text) => {
              this.props.onChangeText && this.props.onChangeText(text);
              if (!text?.length) {
                this.setState({ noSuggestions: true, firstSuggestion: null });
              }
              this.setState({ text });
            }}
            // autoFocus={this.props.preventAutoFocus || !ENV.WEB ? false : true}
            autoFocus={false}
            submitFirstOnPressEnter={!disableSuggestions}
            setFirstSuggestion={(firstSuggestion) =>
              this.setState({ firstSuggestion })
            }
            onSetShift={(shift) => this.setState({ shift })}

            captureEnterOnlyWithItem={ENV.WEB && !disableSuggestions}
            onEnter={(item) => {
              console.log("enter", item);
              // if (!ENV.WEB) Keyboard.dismiss();
              if (!!item) this.selectValue(item);
              else {
                console.log("create !!!!!!!");
                this.handleCreateNote(ENV.WEB ? true : !meta);
                // this.handleCreateNote(
                //   ENV.WEB ? (this.props.defaultToNote ? true : false) : !meta,
                // );
              }
            }}
            onSelectItem={(item) => {
              if (!ENV.WEB) Keyboard.dismiss();
              this.selectValue(item);
            }}
            onShiftEnter={async (item) => {
              // this.handleCreateNote(false);
              this.handleCreateNote(true);
            }}
            onMetaEnter={async (item) => {
              this.handleCreateNote(false);
              // this.selectValue(item);
              // if (item) this.handleProgress(item);
            }}
            onMetaUp={() =>
              this.props.onFocusChapterTitle && this.props.onFocusChapterTitle()
            }
            onMetaDown={() => {
              if (this.props.getUnscopedChildren)
                this.props.getUnscopedChildren();
              else if (this.props.onMetaDown) this.props.onMetaDown();
            }}
            onSetMeta={(meta) => this.setState({ meta })}
            onSetShift={(shift) => this.setState({ shift })}
            onNatDown={!!text?.length ? undefined : this.props.focusNext}
            onNatUp={!!text?.length ? undefined : this.props.focusPrevious}
            onNatLeft={
              !!text?.length ? undefined : this.props.onFocusPreviousChapter
            }
            onNatRight={
              !!text?.length ? undefined : this.props.onFocusNextChapter
            }
            onAltLeft={
              !!text?.length
                ? undefined
                : () => {
                    this.props.onFocusPreviousChapter &&
                      this.props.onFocusPreviousChapter();
                  }
            }
            onAltRight={
              !!text?.length
                ? undefined
                : () => {
                    this.props.onFocusNextChapter &&
                      this.props.onFocusNextChapter();
                  }
            }
            onAltUp={
              !!text?.length
                ? undefined
                : () => {
                    this.props.onFocusChapterTitle
                      ? this.props.onFocusChapterTitle()
                      : this.props.onCollapseChapter && this.props.onCollapseChapter();
                  }
            }
            onAltDown={
              !!text?.length
                ? undefined
                : () => {
                    this.props.onExpandChapter && this.props.onExpandChapter();
                  }
            }
            onFocus={this.props.onFocus}
            onBlur={this.props.onBlur}
            simpleListView
          />

          {/*!!text?.length &&
            (meta ? (
              <TouchableOpacity onPress={() => null}>
                <Text numberOfLines={1} style={this.styles().tip}>
                  new value{" "}
                  <MaterialCommunityIcons
                    name={"apple-keyboard-command"}
                    // style={style}
                    color={this.context.colors.trim}
                  />
                  <AntDesign
                    name={"enter"}
                    // style={style}
                    color={this.context.colors.trim}
                  />{" "}
                </Text>
              </TouchableOpacity>
            ) : shift ? (
              <TouchableOpacity onPress={() => this.handleCreateNote(!shift)}>
                <Text numberOfLines={1} style={this.styles().tip}>
                  {"new note"}{" "}
                  <MaterialCommunityIcons
                    name={"apple-keyboard-shift"}
                    color={this.context.colors.trim}
                  />
                  <AntDesign
                    name={"enter"}
                    // style={style}
                    color={this.context.colors.trim}
                  />{" "}
                </Text>
              </TouchableOpacity>
            ) : !!firstSuggestion ? (
              <TouchableOpacity
                onPress={() => this.selectValue(firstSuggestion)}
              >
                <Text numberOfLines={1} style={this.styles().tip}>
                  pin item{" "}
                  <MaterialIcons name={"push-pin"} color={this.context.colors.trim} />{" "}
                </Text>
              </TouchableOpacity>
            ) : null)*/}
        </View>

        {this.renderParents()}

        {!!text?.length && (
          <View
            style={{
              alignSelf: "stretch",
              flexDirection: "row",
              justifyContent: "space-between",
              paddingLeft: this.context.sizes.bulletWidth,
              paddingRight: this.context.sizes.small,
            }}
          >
            {noSuggestions ? (
              <TouchableOpacity
                haptics
                onPress={() => this.setState({ noSuggestions: false })}
              >
                <Text numberOfLines={1} style={this.styles().tip}>
                  ⇥ suggestions
                </Text>
              </TouchableOpacity>
            ) : (
              <View />
            )}
            <View
              style={{
                alignSelf: "stretch",
                flexDirection: "row",
                justifyContent: "flex-end",
              }}
            >
              <TouchableOpacity
                haptics
                onPress={() => {
                  if (ENV.WEB) {
                    if (meta) this.handleCreateNote(false);
                    else if (shift) this.handleCreateNote(true);
                    else if (!!firstSuggestion)
                      this.selectValue(firstSuggestion);
                  } else {
                    if (!!firstSuggestion) this.selectValue(firstSuggestion);
                    else if (meta) this.setState({ meta: false, shift: true });
                    else if (shift) this.setState({ meta: true, shift: false });
                  }
                }}
              >
                {ENV.WEB ? (
                  <Text numberOfLines={1} style={this.styles().tip}>
                    {meta
                      ? "value"
                      : shift
                      ? "note"
                      : !!firstSuggestion
                      ? "select"
                      : " "}{" "}
                    <AntDesign
                      name={"enter"}
                      color={
                        meta || shift || !!firstSuggestion
                          ? this.context.colors.trim
                          : this.context.colors.transparent
                      }
                      style={{ paddingRight: this.context.sizes.small }}
                    />
                    <MaterialCommunityIcons
                      name={"apple-keyboard-shift"}
                      color={
                        shift
                          ? this.context.colors.active
                          : meta || !!firstSuggestion
                          ? this.context.colors.transparent
                          : this.context.colors.trim
                      }
                      style={{ paddingRight: this.context.sizes.small }}
                    />
                    <MaterialCommunityIcons
                      name={"apple-keyboard-command"}
                      color={
                        meta
                          ? this.context.colors.active
                          : shift || !!firstSuggestion
                          ? this.context.colors.transparent
                          : this.context.colors.trim
                      }
                    />
                  </Text>
                ) : (
                  <Text numberOfLines={1} style={this.styles().tip}>
                    {!!firstSuggestion
                      ? "select"
                      : meta
                      ? "value"
                      : shift
                      ? "note"
                      : " "}{" "}
                  </Text>
                )}
              </TouchableOpacity>
            </View>
          </View>
        )}
      </View>
    );
  }

  renderParents = () => {
    let { parents } = this.state;
    if (!parents?.length) return null;
    return (
      <View style={{ flexDirection: "row" }}>
        {parents.map((parent) => {
          return (
            <Tag
              key={parent.id}
              small
              value={parent}
              onPress={() => {
                let newParents = parents.filter((p) => p.id != parent.id);
                this.setState({ parents: newParents });
              }}
            />
          );
        })}
      </View>
    );
  };

  maybeCreateChapter = async () => {
    let {
      chapter,
      autoCreateChapter,
      onUpdateChapter,
      atemporal,
      parentChapter,
    } = this.props;
    let chapterId = chapter?.id;
    if (chapterId != "today") {
      if (autoCreateChapter && (!chapterId || typeof chapterId == "string")) {
        let data = { atemporal };
        if (!!chapter?.start_at && !!chapter?.end_at) {
          data.start_at = chapter.start_at;
          data.end_at = chapter.end_at;
        }
        let res = await chapterActions.create(data, parentChapter);
        if (!!res?.chapter && !!onUpdateChapter) {
          await onUpdateChapter(res.chapter);
          chapterId = res.chapter.id;
        }
      }
    }
    return chapterId;
  };

  handleCreateNote = async (is_note = false) => {
    // let makeMoment = !is_note;
    // let category = is_note ? "note" : "event";
    let category = is_note ? "note" : "project";
    let makeMoment = false;
    let {
      chapter,
      parentId,
      parentIsValue,
      rootChapter,
      onSubmit,
      createWithParams,
      parentIsChild,
    } = this.props;
    let { text, parents } = this.state;

    let lat = null;
    let lon = null;
    // Optimized: Only fetch location for location-specific categories (events)
    // to avoid blocking UI on every create
    if (category === "event" || this.props.requireLocation) {
      let location = await locationHelpers.getLocation();
      if (!!location?.coords) {
        lat = location.coords.latitude;
        lon = location.coords.longitude;
      }
    }

    let parent_ids = parents.map((p) => p.id);
    if (!!text?.length) {
      if (!!onSubmit) {
        onSubmit(text);
        return;
      }
      // Clear text immediately so the input feels responsive
      this.setState({ text: "", parents: [], noSuggestions: true, firstSuggestion: null });

      let chapterId = null;
      if (!!parentIsValue) {
        makeMoment = false;
        // inhert chapter_id
        chapterId = !rootChapter?.is_value && rootChapter?.id;
      } else {
        chapterId = await this.maybeCreateChapter();
      }

      let title = is_note ? null : text;
      let body = is_note ? text : null;
      // multiline content is a freewrite entry: the whole thing becomes the
      // value body, with the first line (≤80 chars) as the working title
      if (!is_note && /[\r\n]/.test((text || "").trim())) {
        let firstLine =
          (text.split(/[\r\n]/).find((l) => !!l.trim()) || "").trim();
        title = (firstLine || text.trim()).slice(0, 80);
        body = text;
      }

      if (parentIsChild) {
        makeMoment = false;
        let child_ids = !!parentId ? [parentId] : [];
        let value = await valueActions.create(
          {
            title: title,
            text: body,
            child_ids,
            parent_ids,
            ...(createWithParams || {}),
            is_note,
            category,
            lat,
            lon,
          },
          chapterId,
        );
      } else {
        if (!rootChapter?.id) {
          alert("no chapter, should this create a value or a moment?");
          return;
        }
        if (!!parentId) parent_ids.push(parentId);
        parent_ids = textHelpers.uniq(parent_ids);
        if (!makeMoment) {
          let value = await valueActions.create(
            {
              title: title,
              text: body,
              parent_ids,
              ...(createWithParams || {}),
              lat,
              lon,
              category,
            },
            chapterId,
          );
          this.props.onAddChild && this.props.onAddChild(value);
        } else {
          let moment = await momentActions.create({
            title: title,
            text: body,
            value_id: !!parent_ids && parent_ids[0],
            value_ids: parent_ids,
            ...(createWithParams || {}),
            lat,
            lon,
            category,
            chapter_id: chapterId,
            chapter_ids: chapterId && [chapterId],
          });
          this.props.onAddChild && this.props.onAddChild(moment);
        }
      }
      this.props.onRefreshChapter && this.props.onRefreshChapter();
    }
  };

  selectValue = async (item) => {
    let { text, parents } = this.state;
    let addParent = text?.includes("#");
    if (addParent) {
      // await valueActions.toggleParent(value, parent);
      if (parents.find((p) => p.id == item.id))
        parents.splice(
          parents.findIndex((p) => p.id == item.id),
          1,
        );
      else parents.push(item);
      text = text.split("#")[0];
      this.setState({ text, parents, noSuggestions: true, firstSuggestion: null });
    } else {
      this.handlePinValue(item);
    }
  };

  handlePinValue = async (item) => {
    let { chapter, parentId, parentIsValue, parentIsChild, rootChapter } =
      this.props;
    if (item?.id) {
      // full override: the parent decides what pinning means (e.g. journey
      // beats that only record a link when a relationship already exists)
      if (!!this.props.onPinValue) {
        await this.props.onPinValue(item);
        // pinning ends suggestion mode — the next typing session starts
        // clean until Tab re-opens it
        this.setState({
          text: "",
          parents: [],
          noSuggestions: true,
          firstSuggestion: null,
        });
        this.props.onRefreshChapter && this.props.onRefreshChapter();
        return;
      }
      try {
        let pinValueRes;
        if (item.type == "moment") {
          let chapterId = await this.maybeCreateChapter();
          pinValueRes = await momentActions.pinToChapter(item.id, chapterId);
        } else if (parentIsValue) {
          if (parentIsChild) {
            let res = await valueActions.addParent(parentId, item);
          } else {
            let res = await valueActions.addChild(parentId, item);
            if (!!rootChapter?.id && !rootChapter?.is_value) {
              let pinRes = await chapterActions.pinValue(
                rootChapter?.id,
                item.id,
              );
            }
          }
        } else {
          let chapterId = await this.maybeCreateChapter();
          pinValueRes = await chapterActions.pinValue(chapterId, item.id);
        }
        // prompt to re-open completed value
        if (!!item.completed_at) {
          let res = await valueActions.complete(
            item,
            null,
            true,
            pinValueRes?.moment?.id,
            chapter?.id,
          );
        }
        // pinning ends suggestion mode — the next typing session starts
        // clean until Tab re-opens it
        this.setState({
          text: "",
          parents: [],
          noSuggestions: true,
          firstSuggestion: null,
        });
        this.props.onPinnedValue && this.props.onPinnedValue(item);
        this.props.onRefreshChapter && this.props.onRefreshChapter();
      } catch (e) {
        console.error("handlePinValue error:", e);
      }
    }
  };

  handleProgress = async (value) => {
    let { chapter, parentId } = this.props;
    let chapterId = await this.maybeCreateChapter();
    let timestamp = undefined;
    if (!!chapter && !chapter?.current) {
      timestamp = timeHelpers.averageTimes([
        timeHelpers.dateToDateTime(chapter.start_at),
        timeHelpers.endOfDay(timeHelpers.dateToDateTime(chapter.end_at)),
      ]);
    }
    let res = await valueActions.progress(value.id, timestamp);
    this.setState({
      text: "",
      parents: [],
      noSuggestions: true,
      firstSuggestion: null,
    });
    this.props.onRefreshChapter && this.props.onRefreshChapter();
  };

  addNode = (node) => {};

  styles = () => ({
    row: {},
    tip: {
      color: this.context.colors.trim,
      // position: "absolute", // this makes it disappear...?
      // right: 0,
      // textWrap: "nowrap",
      // width: 150,
      textAlign: "right",
      paddingRight: this.context.sizes.base,
      paddingVertical: ENV.WEB ? 0 : this.context.sizes.large,
    },
  });
}
